import React, { Component } from 'react';
import { Button, Modal } from "react-bootstrap";

interface OfdConfirmationModalProps {}

interface OfdConfirmationModalState {
    isOpen: boolean
}

class OfdConfirmationModal extends Component<OfdConfirmationModalProps, OfdConfirmationModalState> {

    constructor(props: OfdConfirmationModalProps) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    async componentDidMount() {
        try {
            // todo: load result from server. only show popup, when field is null

            if (false) {
                this.setState({
                    isOpen: true
                });
            }

        } catch (e) {
            console.log("Error in loading: " + e);
        }
    }

    close() {
        this.setState({
            isOpen: false
        })
    }


    render() {
        return (
            <Modal show={this.state.isOpen} size='lg'>
                <Modal.Body>
                    Als Lohnsteuerhilfeverein sind wir gesetzlich verpflichtet die Änderungen von Grunddaten an die zuständige Aufsichtsbehörde / Oberfinanzdirektion (OFD) zu übermitteln.<br />
                    Ich stimme zu, dass Änderungen meiner Beratungsstelle transportverschlüsselt per E-Mail (TLS 1.2) an die zuständige Aufsichtsbehörde / OFD übersendet werden dürfen.<br />
                    Durch die Übermittlung per E-Mail wird i.d.R. eine schnellere Bearbeitung erfolgen.<br />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={(e) => {console.log("Ja an Server"); this.close();}}>
                        Ja
                    </Button>
                    <Button variant="secondary" onClick={(e) => {console.log("Nein an Server"); this.close();}}>
                        Nein
                    </Button>
                    Wenn Sie dem nicht zustimmen, werden Änderungen weiterhin per Briefpost an die Aufsichtsbehörde / OFD gesendet.
                </Modal.Footer>
            </Modal>
        );
    }
}

export default OfdConfirmationModal;